import {Component, Input, OnInit, QueryList, ViewChildren} from '@angular/core';
import {Payment, Transaction} from "../../models";
import {CopyToClipboardComponent} from "../../shared/components/copy-to-clipboard/copy-to-clipboard.component";
import { BANK_GU_IDS } from 'src/app/core/constants/payMethods-gu';

@Component({
  selector: 'app-payment-from-website',
  templateUrl: './payment-from-website.component.html',
  styleUrls: ['./payment-from-website.component.scss']
})
export class PaymentFromWebsiteComponent implements OnInit {

  @Input() info: Payment[];
  @Input() transaction: Transaction;
  @Input() currentConcept: any;
  @ViewChildren(CopyToClipboardComponent) copiesComponents: QueryList<CopyToClipboardComponent>;
  isBamWeb : boolean = false;

  constructor() {
  }

  ngOnInit() {
    this.info.forEach(webpayment  => {
      if (webpayment.code === BANK_GU_IDS.BAM_PAY_WEB) {
        this.isBamWeb = true;
      }
    });
  }
}
